import React from 'react';
import { Box, Grid, Stack, Typography } from '@cherre-frontend/ui';
import { useActiveCustomPropertyAttributes } from '../../hooks/useCustomPropertyAttributes';

const legend = [
  { label: 'Target', color: '#9F4182' },
  { label: 'Source', color: '#FF6294' },
];

export const CustomPropertyAttributesLegend = () => {
  const attributes = useActiveCustomPropertyAttributes();

  if (!attributes || attributes.length === 0) {
    return null;
  }

  return (
    <Grid item marginLeft='auto'>
      <Stack direction='row' gap={2}>
        {legend.map(({ label, color }) => (
          <Stack key={label} direction='row' gap={1} alignItems='center'>
            <Box
              width={10}
              height={10}
              borderRadius={5}
              sx={{ backgroundColor: color }}
            />
            <Typography fontWeight='bold'>{label}</Typography>
          </Stack>
        ))}
      </Stack>
    </Grid>
  );
};
